/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, RoutePath } from "../../../utility/Constant";

const NewsAndEventsUniquePage = () => {
  const { newsAndEventsApi } = apiPath;
  const [newsAndEventsUniqueData, newsAndEventsUniqueLoading] =
    useFetch(newsAndEventsApi);
  const [filteredData, setFilteredData] = useState();
  let { id } = useParams();

  useEffect(() => {
    setFilteredData(
      newsAndEventsUniqueData?.filter((item) => item._id === id)[0]
    );
  }, [newsAndEventsUniqueData, id]);

  if (newsAndEventsUniqueLoading || !filteredData?._id) {
    return <Loading />;
  }

  const { date, title, content, short_description, source_name, source_link, banner_image, _id } =
    filteredData ?? {};


  const data = [
    {
      elementType: "input",
      label: "title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: true,
    },
    {
      elementType: "input",
      label: "Short Description",
      type: "Text",
      name: "short_description",
      defaultValue: short_description,
      required: true,
    },
    // {
    //   elementType: "input",
    //   label: "title on popup",
    //   type: "Text",
    //   name: "title_on_popup",
    //   defaultValue: title_on_popup,
    //   required: false,
    // },
    {
      elementType: "input",
      label: "date",
      type: "date",
      name: "date",
      defaultValue: date,
      required: false,
    },
    // {
    //   elementType: "textField",
    //   label: "description",
    //   type: "Text",
    //   name: "description",
    //   defaultValue: description,
    //   required: false,
    // },
    {
      elementType: "input",
      label: "Source Name",
      type: "Text",
      name: "source_name",
      defaultValue: source_name,
      required: false,
    },
    {
      elementType: "input",
      label: "Source Link",
      type: "Text",
      name: "source_link",
      defaultValue: source_link,
      required: false,
    },
    {
      elementType: "file",
      label: `Banner Image`,
      name: "banner_image",
      type: "file",
      fullCol: true,
      defaultValue: banner_image,
      required: false,
    },
    {
      elementType: "richTextEditor",
      label: "Content",
      type: "richTextEditor",
      name: "content",
      defaultValue: content || "",
      required: false,
    },
  ];

  const update = (data) => {
    const { banner_image, ...rest } = data;
    rest.banner_image = {
      url: banner_image,
    };
    updateData(newsAndEventsApi, rest, _id);
    setTimeout(() => {
      window.location.href = "/" + RoutePath.aboutUsNews;
    }, 600);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default NewsAndEventsUniquePage;
